var render = function render(){var _vm=this,_c=_vm._self._c;return _c('iframe',{staticClass:"iframe",attrs:{"src":`https://variant-browser.molit.eu/search${_vm.queryString}`}})
}
var staticRenderFns = []

export { render, staticRenderFns }